import { Obj, Str } from '@livecontrol/core-utils';
import { Errors } from '@livecontrol/scheduler/store';
import type * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
import _ from 'lodash';
import { useCallback, useState } from 'react';
import { Token } from '../../model';
import { store } from '../factory';

interface TVariables {
  name: string;
  password: string;
}

type Args = TVariables;

export const useConfirmUser = (): [
  (args: Args) => void,
  {
    error?: Error;
    token?: Token;
    webplayerToken?: string;
    loading: boolean;
  }
] => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>();
  const [token, setToken] = useState<Token | undefined>();
  const [webplayerToken, setWebplayerToken] = useState<string | undefined>();

  return [
    useCallback((args: Args): void => {
      try {
        // Parse the input arguments
        const variables = {
          name: Str.normalize(args.name),
          password: Str.normalize(args.password)
        };

        // Validate the input
        if (!Obj.isHydrated(variables)) {
          throw Errors.badRequest();
        }

        setLoading(true);

        const { awsCognitoUser } = store.getState();

        const callbacks: AmazonCognitoIdentity.IAuthenticationCallback = {
          onSuccess: (result) => {
            const accessToken = result.getAccessToken().getJwtToken();
            const decoded = Token.decode(accessToken);

            setLoading(false);
            setToken(decoded);
            setWebplayerToken(undefined);
          },
          onFailure: (err) => {
            setError(<Error>err);
            setLoading(false);
          }
        };

        awsCognitoUser?.completeNewPasswordChallenge(
          variables.password,
          _.pick(variables, ['name']),
          callbacks
        );
      } catch (error_: unknown) {
        setError(<Error>error_);
        setLoading(false);
      }
    }, []),
    {
      token,
      webplayerToken,
      error,
      loading
    }
  ];
};
